const { $, dict, UIkit, rz } = window;

const usr = {};

const queryStringParams = new Proxy(new URLSearchParams(window.location.search), { get: (searchParams, prop) => searchParams.get(prop) });

usr.getSettings = async () => {
  const res = await fetch("/api/usersettings", {method: "GET", headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
  if (!res.ok) { return {result: false, err: "Error response status: " + res.status} }
  const ssnsHeader = res.headers.get("X-Session-Info") || "";
  let ssns;
  try { ssns = rz.objFromJSON(rz.Base64decode(ssnsHeader || "")) } catch (err) { console.log(err) }
  if (!ssns || !ssns.userip || !ssns.lng || !ssns.theme) { return {result: false, err: "Invalid session metadata"} }

  const key = await rz.getCryptoKey({session: ssns});
  if (!key) { return {result: false, err: "Invalid Crypto Key"} }

  const encryptedBuffer = await res.arrayBuffer();
  const ans2 = await rz.decryptData(encryptedBuffer, key);
  if (ans2.err || !ans2.data) { return {result: false, err: ans2.err || "Crypto Error"} }
  return ans2.data;
};

$(document).ready(() => {
  if (window.location.pathname === "/login") {
    const {login, pass} = queryStringParams;
    if (login) $("input#fieldlogin").val(login);
    if (pass) $("input#fieldpass").val(pass);
    if (login && pass) usr.doLogin(login, pass, true);
  }
});

usr.userCheckStatus = async () => {
  const dct = dict[dict.get()];
  const ans = await usr.getSettings();
  const linkuserlogin = $("#linkuserlogin");
  const linkuserparameters = $("#linkuserparameters");
  const linkuserexit = $("#linkuserexit");

  if ((!ans.user || !ans.user.name) && !linkuserlogin[0]) {
    $("#user-menu-button").attr({"dict-uk-tooltip": "p.usermenu", "uk-tooltip": dct.p.usermenu}).html("<i class='fa fa-user-secret'></i>");
    $("#user-menu-ul").empty();
    $("#user-menu-ul").append(`
      <li>
          <a id="linkuserlogin" class="rz-txt-hover-gray" href="/app/login" dict="p.userlogin">
              ` + dct.p.userlogin + `
          </a>
      </li>
    `);
  }
  else if ((ans.user && ans.user.name) && (!linkuserparameters[0] || !linkuserexit[0])) {
    $("#user-menu-button").attr({"dict-uk-tooltip": "", "uk-tooltip": ans.user.name}).html("<i class='fa fa-user'></i>");
    $("#user-menu-ul").empty();
    $("#user-menu-ul").append(`
      <li>
          <a id="userparameters" class="rz-txt-hover-gray uk-disabled" href="#">
            <i class="fa fa-user-o"></i>&nbsp;` + ans.user.name + `
          </a>
      </li>
      <li>
          <a id="linkportal" class="rz-txt-hover-gray" href="/app" dict="p.gotoportal">
            ` + dct.p.gotoportal + `
          </a>
      </li>
      <li>
          <a id="linkuserexit" class="rz-txt-hover-gray" href="#" dict="p.userexit">
              ` + dct.p.userexit + `
          </a>
      </li>
    `);
  }

  // User-menu
  $("#linkuserexit").click(() => usr.userExit());
  // $("#linkuserlogin").click(() => usr.userLogin());
  return ans;
};

usr.userLogin = async () => {
  const dct = dict[dict.get()];
  const middlePromiseCheckSSO = () => new Promise((resolve) => {
    usr.getSettings().then((cfg) => {
      // eslint-disable-next-line max-len
      fetch(cfg.links.srvbg + "/api/ssocheck", {method: "POST", headers: {"Content-Type": "application/json;charset=utf-8"}}).then((res1) => res1.json()).then((jsn1) => {
        resolve(jsn1);
      }).catch((err1) => { console.log(err1); resolve({result: false, err: err1}) });
    }).catch((err0) => { console.log(err0); resolve({result: false, err: err0}) });
  });
  const middlePromiseLoginSSO = (hash) => new Promise((resolve) => {
    // eslint-disable-next-line max-len
    fetch("/api/ssologin", {method: "POST", body: JSON.stringify({hash, userip: window.cfg1910ar?.userip}), headers: {"Content-Type": "application/json;charset=utf-8"}}).then((res2) => res2.json()).then((jsn2) => {
      resolve(jsn2);
    }).catch((err2) => { console.log(err2); resolve({result: false, err: err2}) });
  });

  // Step-1: Try to login using sso-authorization
  const jsn1 = await middlePromiseCheckSSO();
  if (jsn1.result && jsn1.hash) {
    const jsn2 = await middlePromiseLoginSSO(jsn1.hash);
    if (jsn2.result && jsn2.user && jsn2.user.name) {
      UIkit.notification({ message: dct.i.userLoggedSuccess, status: "success", pos: "bottom-center", timeout: 3000 });
      window.cfg1910ar = await usr.userCheckStatus();
      window.location.href = "/app";
      return true;
    }
  }

  // Step-2: Standart authorization -> redirect to page 'login'
  let qs = "";
  if (!rz.arrContains(["/", "/login"], window.location.pathname)) qs = "?url=" + encodeURIComponent(window.location.pathname);
  window.location.href = "/login" + qs;
  return true;
};

usr.userExit = async () => {
  // body: JSON.stringify({action: "userexit"})
  await fetch("/api/userexit", {method: "POST", headers: {"Content-Type": "application/json;charset=utf-8"}});
  window.cfg1910ar = await usr.userCheckStatus();
  window.location.href = "/";
  return true;
};

// LOGIN form check
usr.validateLogin = (login) => (Boolean(login.length > 2 && login.length < 50));
usr.validatePass = (pass) => (Boolean(pass.length > 5 && pass.length < 50));

$("#fieldlogin").on("keyup", (e) => {
  const login = $(e.target).val().trim();
  if (usr.validateLogin(login)) { $(e.target).removeClass("uk-form-danger").addClass("uk-form-success") }
  else { $(e.target).removeClass("uk-form-success").addClass("uk-form-danger") }
});

$("#fieldpass").on("keyup", (e) => {
  const pass = $(e.target).val().trim();
  if (usr.validateLogin(pass)) { $(e.target).removeClass("uk-form-danger") }
  else { $(e.target).addClass("uk-form-danger") }
});

$("#loginbutton").on("click", async (e) => {
  e.preventDefault();
  const login = $("#fieldlogin").val().trim(), pass = $("#fieldpass").val().trim();
  let haserr = false;
  if (!usr.validateLogin(login)) { $("#fieldlogin").removeClass("uk-form-success").addClass("uk-form-danger"); haserr = true }
  if (!usr.validatePass(pass)) { $("#fieldpass").addClass("uk-form-danger"); haserr = true }
  if (!haserr) { await usr.doLogin(login, pass) }
  $("#fieldpass").val("");
});

usr.doLogin = async (login, pass, encoded) => {
  const redirectUrl = queryStringParams.url || "/app";

  const data = {login, pass: (encoded ? pass : rz.strReverse(rz.Base64encode(pass)))};
  const res = await fetch("/api/stdlogin", {method: "POST", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8"}});
  const ans = await res.json();
  rz.log({message: ans, caller: "user.js -> doLogin()"});
  if (ans.result && ans.user && ans.user.login) {
    UIkit.notification({ message: dict[dict.get()].i.userLoggedSuccess, status: "success", pos: "bottom-center", timeout: 3000 });
    window.cfg1910ar = await usr.userCheckStatus();
    await rz.delay(1000);
    window.location.href = redirectUrl;
    return;
  }

  if (ans.banned) { window.location.href = "/ban" }
  const err = ans.err || "Invalid Credentials! You may be blocked!";
  UIkit.notification({ message: rz.errToString(err), status: "danger", pos: "bottom-center", timeout: 5000 });
};

export default usr;
